module.exports = __webpack_public_path__ + "static/media/computer-editing.3c1c9c0e.svg";